import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreateOrderCross from './create-order';
import Help from '../../../helper/help';
import {setOrderType} from '../../../../actions/ui/marketplace';
import {matchOrders} from '../../../../actions/orderbook/matchingEngine';

class PlaceOrder extends Component {
  setOrderType(type){
    setTimeout(()=>{
      this.props.setOrderType(type);
      setTimeout(()=>{
        if(this.props.amount && this.props.price){
          this.props.matchOrders();
        }
      },200);
    },200);
  }
  renderChoose(){
    let curr = this.props.market.asset;
    let buy = `Buy ${curr}`;
    let sell = `Sell ${curr}`;

    let buyStyle = this.props.orderType == 'BUY' ? {
      color: '#65ad61',
      padding:0,
      borderRight: '1px solid grey',
    } :
    {
      color: 'grey',
      padding:0,
      borderRight: '1px solid grey',
      borderBottom: '1px solid grey',
    }

    let sellStyle = this.props.orderType == 'SELL' ? {
      color: '#de7272',
      padding:0,
    } :
    {
      color: 'grey',
      padding:0,
      borderBottom: '1px solid grey',
    }

    let backgroundBuy = this.props.orderType == 'SELL' ? '#050505' : '';
    let backgroundSell = this.props.orderType == 'BUY' ? '#050505' : '';

    return (
      <div className="row">
        <ul className="tabs2 tabs" id='tabs2'>
          <li className="tab col s6" style={{background:backgroundBuy}}> <a href="#" className="active" id='acquire' onClick={this.setOrderType.bind(this,'BUY')} style={buyStyle}>{buy}<Help/></a></li>
          <li className="tab col s6" style={{background:backgroundSell}}> <a href="#" id='leaseout' style={sellStyle} onClick={this.setOrderType.bind(this,'SELL')}>{sell}<Help/></a></li>
        </ul>
      </div>
    )
  }
  render() {
    return (
      <div className="col s12" id='padding'>
         {this.renderChoose()}
         <CreateOrderCross/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orderType: state.ui_marketplace.orderType,
    market: state.ui_marketplace.market,
    price: state.ui_marketplace.price,
    amount: state.ui_marketplace.amount
  }
}

export default connect(mapStateToProps, {setOrderType,matchOrders})(PlaceOrder);
